module.exports = __webpack_public_path__ + "img/bg12.c591abeb.png";